import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "menu-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "theme-color" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "theme-color" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_nav = _resolveComponent("my-nav")
  const _component_el_menu_item_group = _resolveComponent("el-menu-item-group")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_badge = _resolveComponent("el-badge")
  const _component_el_menu_item = _resolveComponent("el-menu-item")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.menuList, (v) => {
      return (_openBlock(), _createBlock(_Fragment, {
        key: v.name
      }, [
        (v.children && v.children.length > 0 )
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              (!v.meta.hide)
                ? (_openBlock(), _createBlock(_component_el_submenu, {
                    index: v.name,
                    key: v.name,
                    class: "theme-bg"
                  }, {
                    title: _withCtx(() => [
                      _createVNode("i", {
                        class: ["iconfont theme-color", v.meta.icon]
                      }, null, 2),
                      _createVNode("span", _hoisted_3, _toDisplayString(v.meta.name), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item_group, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_my_nav, {
                            menuList: v.children
                          }, null, 8, ["menuList"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              (!v.meta.hide)
                ? (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: v.name,
                    index: v.name,
                    onClick: ($event: any) => (_ctx.gotoRoute(v.name)),
                    class: "theme-bg"
                  }, {
                    default: _withCtx(() => [
                      _createVNode("i", {
                        class: ["iconfont theme-color", v.meta.icon]
                      }, null, 2),
                      _createVNode("span", _hoisted_5, _toDisplayString(v.meta.name), 1),
                      (_ctx.state.workTotal[v.name])
                        ? (_openBlock(), _createBlock(_component_el_badge, {
                            key: 0,
                            value: _ctx.state.workTotal[v.name],
                            max: 10,
                            class: "item",
                            type: "danger"
                          }, null, 8, ["value"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["index", "onClick"]))
                : _createCommentVNode("", true)
            ]))
      ], 64))
    }), 128))
  ]))
}